<template>
    <el-row type="flex" justify="space-around" :gutter="20">
        <el-col :span="6">
            <div id="qrcode" ref="qrcode"></div>
        </el-col>
        <el-col>
            <el-form :model="miniScheme"  label-width="100px" class="demo-ruleForm">
                <el-form-item label="名称：" >
                    <el-input v-model="miniScheme.schemeName" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="小程序链接：" >
                    <el-input v-model="this.miniPath" disabled="disabled" type="textarea"
                              :autosize="{ minRows: 1, maxRows: 2}"></el-input>
                </el-form-item>
              <el-form-item label="企微链接：" >
              <el-input v-model="this.miniPath2" disabled="disabled" type="textarea"
                        :autosize="{ minRows: 1, maxRows: 2}"></el-input>
              </el-form-item>
                <el-form-item label="扫码链接：" >
                    <el-input v-model="miniScheme.openLink" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="短链接：" >
                    <el-input v-model="miniScheme.shortLink" disabled="disabled"></el-input>
                </el-form-item>

            </el-form>

        </el-col>

    </el-row>

</template>

<script>
    //导入 HTTP请求方法
    import {getMiniSchemeSystem,getMiniSchemeSystemByPara} from '../api/api'
    import QRCode from 'qrcodejs2'//引入方法
    //定义组件
    export default{
        data(){
            return {
                miniPath:"",
                miniPath1:"",
                miniPath2:"",
                miniScheme:{queryPara:'',miniPath:''},
            }
        },
        //挂载时候执行
        mounted(){
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                width: 188,
                height: 188,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });
            //展示二维码
            getMiniSchemeSystemByPara({miniPath:this.path}).then((res) => {
                if (res.data.status == 200) {
                    console.log(res);
                    this.miniScheme = res.data.value;
                    if(res.data.value.schemeName==''){
                        this.miniScheme.schemeName=this.schemeName
                    }
                    console.log(this.miniScheme);
                    this.miniPath = this.miniScheme.queryPara == '' ? this.miniScheme.miniPath : this.miniScheme.miniPath + '?' + this.miniScheme.queryPara;
                    this.miniPath1 = this.setMiniUrl(this.miniPath);
                    this.miniPath2 = this.setQwUrl(this.miniPath);
                    qrcode.makeCode(this.miniScheme.shortLink);
                }else {
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
                //qrcode.makeCode(this.miniPath1);
            });
        },
        methods:{
            setMiniUrl(url){
                let reg = new RegExp("(\\w+)?(\\/pages)?(\\/\\w+)(\\/index)?(\\?\\S*)?")
                let urlPathName = url.replace(reg,'$3')
                let urlSearch = url.replace(reg,'$5')
                let minUrlPathName = url.split('?')[0]
                let urlLink = 'http://lechun.cc'+urlPathName+urlSearch
                console.log('minUrlPathName='+minUrlPathName)
                console.log('urlLink='+urlLink)
                console.log('urlSearch='+urlSearch)
                console.log('urlPathName='+urlPathName)
                return `${minUrlPathName}.html?type=open&targeturl=${encodeURIComponent(urlLink)}`
            },
          setQwUrl(url){
            let arr=url.split('?')
            let minUrlPathName =arr[0]
            return `${minUrlPathName}.html?${arr[1]}`
          }
        },
        props:["path","schemeName"],
    }

</script>

<style lang="scss" rel="stylesheet/scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/PreviewByPath.vue